import React from "react";
import { Link, useLocation } from "react-router-dom";

const biOptions = [
  { label: "Inventario Simple", route: "/inteligencia-negocios/inventario-simple" },
  { label: "Inventario", route: "/inteligencia-negocios/inventario" },
  { label: "Ventas Diarias", route: "/inteligencia-negocios/ventas-diarias" },
  { label: "Clientes Inactivos", route: "/inteligencia-negocios/clientes-inactivos" },
  { label: "Apertura", route: "/inteligencia-negocios/apertura" },
  { label: "Comparativo", route: "/inteligencia-negocios/comparativo" },
  { label: "Transferencias", route: "/inteligencia-negocios/transferencias" },
  { label: "Config", route: "/inteligencia-negocios/transferencias/configuracion" },
];

export function BISidebar() {
  const location = useLocation();

  return (
    <nav className="flex flex-wrap gap-1 border-b border-gray-200 pb-2">
      {biOptions.map((option, index) => {
        const isActive = location.pathname === option.route;
        return (
          <Link key={`bi_tab_${index}`} to={option.route}>
            <span
              className={`inline-block px-3 py-1.5 text-sm rounded-md transition-colors ${
                isActive
                  ? "bg-purple text-white font-medium"
                  : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              }`}
            >
              {option.label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}

export default BISidebar;
